module.exports = __webpack_public_path__ + "static/media/credit.5edcde83.svg";